<template>
  <div>
    <div v-if="parameters.version === 'v2'">
      <div class="g-recaptcha" :data-sitekey="parameters.sitekey"></div>
      <input type="hidden" :name="parameters.versionFieldName" :value="parameters.version" />
    </div>
    <div v-if="parameters.version === 'v3'">
      <input
        ref="formVersion"
        type="hidden"
        :name="parameters.versionFieldName"
        :value="parameters.version"
      />
      <input type="hidden" :name="parameters.actionFieldName" :value="parameters.action" />
      <input type="hidden" :name="parameters.responseFieldName" :value="responseToken" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parameters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      responseToken: "",
    };
  },
  mounted() {
    if (this.parameters.version === "v3") {
      this.initV3();
    }
  },
  methods: {
    initV3() {
      window.withRecaptchaLoaded(() => {
        this.$refs.formVersion.form.addEventListener("submit", async e => {
          e.preventDefault();
          this.responseToken = await window.grecaptcha.execute(this.parameters.apiKey, {
            action: this.parameters.action,
          });
          this.$nextTick(() => {
            e.target.submit();
          });
        });
      });
    },
  },
};
</script>
